export default "__VITE_ASSET__B$8YEGXH__"